import { render, staticRenderFns } from "./welcome-numbering-plan.vue?vue&type=template&id=59a66a9d&scoped=true&"
import script from "./welcome-numbering-plan.vue?vue&type=script&lang=js&"
export * from "./welcome-numbering-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a66a9d",
  null
  
)

export default component.exports